// source: pbtypes/vehicle/skills/actions/spoof_phone_ui_variables/spoof_phone_ui_variables.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_skills_ui_variables_pb = require('../../../../../pbtypes/gen/skills/ui_variables_pb.js');
goog.object.extend(proto, pbtypes_gen_skills_ui_variables_pb);
goog.exportSymbol('proto.skills.SpoofPhoneUiVariablesActionArgs', null, global);
goog.exportSymbol('proto.skills.SpoofPhoneUiVariablesActionStateData', null, global);
goog.exportSymbol('proto.skills.SpoofPhoneUiVariablesResultData', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.SpoofPhoneUiVariablesActionArgs = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skills.SpoofPhoneUiVariablesActionArgs, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.SpoofPhoneUiVariablesActionArgs.displayName = 'proto.skills.SpoofPhoneUiVariablesActionArgs';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.SpoofPhoneUiVariablesResultData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skills.SpoofPhoneUiVariablesResultData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.SpoofPhoneUiVariablesResultData.displayName = 'proto.skills.SpoofPhoneUiVariablesResultData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.SpoofPhoneUiVariablesActionStateData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skills.SpoofPhoneUiVariablesActionStateData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.SpoofPhoneUiVariablesActionStateData.displayName = 'proto.skills.SpoofPhoneUiVariablesActionStateData';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.SpoofPhoneUiVariablesActionArgs.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.SpoofPhoneUiVariablesActionArgs.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.SpoofPhoneUiVariablesActionArgs} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.SpoofPhoneUiVariablesActionArgs.toObject = function(includeInstance, msg) {
  var f, obj = {
durationS: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
phoneUiVariables: (f = msg.getPhoneUiVariables()) && pbtypes_gen_skills_ui_variables_pb.UiVariablesPb.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.SpoofPhoneUiVariablesActionArgs}
 */
proto.skills.SpoofPhoneUiVariablesActionArgs.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.SpoofPhoneUiVariablesActionArgs;
  return proto.skills.SpoofPhoneUiVariablesActionArgs.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.SpoofPhoneUiVariablesActionArgs} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.SpoofPhoneUiVariablesActionArgs}
 */
proto.skills.SpoofPhoneUiVariablesActionArgs.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDurationS(value);
      break;
    case 2:
      var value = new pbtypes_gen_skills_ui_variables_pb.UiVariablesPb;
      reader.readMessage(value,pbtypes_gen_skills_ui_variables_pb.UiVariablesPb.deserializeBinaryFromReader);
      msg.setPhoneUiVariables(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.SpoofPhoneUiVariablesActionArgs.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.SpoofPhoneUiVariablesActionArgs.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.SpoofPhoneUiVariablesActionArgs} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.SpoofPhoneUiVariablesActionArgs.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDurationS();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getPhoneUiVariables();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      pbtypes_gen_skills_ui_variables_pb.UiVariablesPb.serializeBinaryToWriter
    );
  }
};


/**
 * optional double duration_s = 1;
 * @return {number}
 */
proto.skills.SpoofPhoneUiVariablesActionArgs.prototype.getDurationS = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.SpoofPhoneUiVariablesActionArgs} returns this
 */
proto.skills.SpoofPhoneUiVariablesActionArgs.prototype.setDurationS = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional UiVariablesPb phone_ui_variables = 2;
 * @return {?proto.skills.UiVariablesPb}
 */
proto.skills.SpoofPhoneUiVariablesActionArgs.prototype.getPhoneUiVariables = function() {
  return /** @type{?proto.skills.UiVariablesPb} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_skills_ui_variables_pb.UiVariablesPb, 2));
};


/**
 * @param {?proto.skills.UiVariablesPb|undefined} value
 * @return {!proto.skills.SpoofPhoneUiVariablesActionArgs} returns this
*/
proto.skills.SpoofPhoneUiVariablesActionArgs.prototype.setPhoneUiVariables = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skills.SpoofPhoneUiVariablesActionArgs} returns this
 */
proto.skills.SpoofPhoneUiVariablesActionArgs.prototype.clearPhoneUiVariables = function() {
  return this.setPhoneUiVariables(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skills.SpoofPhoneUiVariablesActionArgs.prototype.hasPhoneUiVariables = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.SpoofPhoneUiVariablesResultData.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.SpoofPhoneUiVariablesResultData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.SpoofPhoneUiVariablesResultData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.SpoofPhoneUiVariablesResultData.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.SpoofPhoneUiVariablesResultData}
 */
proto.skills.SpoofPhoneUiVariablesResultData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.SpoofPhoneUiVariablesResultData;
  return proto.skills.SpoofPhoneUiVariablesResultData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.SpoofPhoneUiVariablesResultData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.SpoofPhoneUiVariablesResultData}
 */
proto.skills.SpoofPhoneUiVariablesResultData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.SpoofPhoneUiVariablesResultData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.SpoofPhoneUiVariablesResultData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.SpoofPhoneUiVariablesResultData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.SpoofPhoneUiVariablesResultData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.SpoofPhoneUiVariablesActionStateData.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.SpoofPhoneUiVariablesActionStateData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.SpoofPhoneUiVariablesActionStateData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.SpoofPhoneUiVariablesActionStateData.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.SpoofPhoneUiVariablesActionStateData}
 */
proto.skills.SpoofPhoneUiVariablesActionStateData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.SpoofPhoneUiVariablesActionStateData;
  return proto.skills.SpoofPhoneUiVariablesActionStateData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.SpoofPhoneUiVariablesActionStateData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.SpoofPhoneUiVariablesActionStateData}
 */
proto.skills.SpoofPhoneUiVariablesActionStateData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.SpoofPhoneUiVariablesActionStateData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.SpoofPhoneUiVariablesActionStateData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.SpoofPhoneUiVariablesActionStateData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.SpoofPhoneUiVariablesActionStateData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


goog.object.extend(exports, proto.skills);
